
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as activateS29gYq7aUIMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/auth/activate.vue?macro=true";
import { default as email_45change007Q3PmgBWMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/auth/email-change.vue?macro=true";
import { default as index0dwdLIcNfGMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/auth/index.vue?macro=true";
import { default as register_45completeVBDP4eZ033Meta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/auth/register-complete.vue?macro=true";
import { default as register78tnzTT48bMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/auth/register.vue?macro=true";
import { default as restoreqZDTwOcZWHMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/auth/restore.vue?macro=true";
import { default as indexYLaZLnFSqVMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/buzzer/index.vue?macro=true";
import { default as _91id_93Tug6tIoKAgMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/dashboards/[id].vue?macro=true";
import { default as indexazVHRFwGdMMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/dashboards/index.vue?macro=true";
import { default as _91token_930iH5hbd793Meta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/dashboards/token/[token].vue?macro=true";
import { default as tokenlZOU2VRUVlMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/dashboards/token.vue?macro=true";
import { default as demoxpZRwbFDEcMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/demo.vue?macro=true";
import { default as indexu2JP7Gc3snMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/events/index.vue?macro=true";
import { default as impressumDZwg8OXpUzMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/impressum.vue?macro=true";
import { default as indexXfHYhhy8mFMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/index.vue?macro=true";
import { default as _91id_93hfESEFMjc3Meta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/organisation/deals/[id].vue?macro=true";
import { default as indexOSYKnxtUSyMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/organisation/deals/index.vue?macro=true";
import { default as _91id_930vh4jWfVM5Meta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/organisation/devices/[id].vue?macro=true";
import { default as HSLtoRGBqyWFJrW9TbMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/organisation/devices/HSLtoRGB.js?macro=true";
import { default as index5Ip12oA1pTMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/organisation/devices/index.vue?macro=true";
import { default as RGBtoHSLPHgWJ30qs7Meta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/organisation/devices/RGBtoHSL.js?macro=true";
import { default as _91id_93sol6gkBb0uMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/organisation/eventTypes/[id].vue?macro=true";
import { default as index55HIJK8iWyMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/organisation/eventTypes/index.vue?macro=true";
import { default as _91id_93yTQZ43l4vzMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/organisation/goals/[id].vue?macro=true";
import { default as indexZAkJetgRYSMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/organisation/goals/index.vue?macro=true";
import { default as _91id_93eGfBK6U2E3Meta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/organisation/groups/[id].vue?macro=true";
import { default as index588pJjrqRaMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/organisation/groups/index.vue?macro=true";
import { default as index17VPpXe9RvMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/organisation/settings/index.vue?macro=true";
import { default as indexBiE9PR6wqfMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/organisation/subscriptions/index.vue?macro=true";
import { default as _91id_93G0j0ViyMjVMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/organisation/users/[id].vue?macro=true";
import { default as indexSCyK36u4zQMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/organisation/users/index.vue?macro=true";
import { default as _91id_93OO3JotTawzMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/sounds/[id].vue?macro=true";
import { default as entriesZyjZxMqvTFMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/sounds/index/entries.vue?macro=true";
import { default as playlistsetjXF8mSPyMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/sounds/index/playlists.vue?macro=true";
import { default as indexiNL526JGapMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/sounds/index.vue?macro=true";
import { default as indexP6fX1dStJVMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/system/devices/index.vue?macro=true";
import { default as _91id_93liW9IHZ8QPMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/system/firmware/[id].vue?macro=true";
import { default as index0w9eqsmcJyMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/system/firmware/index.vue?macro=true";
import { default as _91id_93VMMZG1Y7bnMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/system/hardware/[id].vue?macro=true";
import { default as indexQhymgqbGotMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/system/hardware/index.vue?macro=true";
import { default as index0ozDoYlwPhMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/system/logs/index.vue?macro=true";
import { default as _91id_93MwZwZWqahoMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/system/notificationTemplates/[id].vue?macro=true";
import { default as indexOpV80duuM8Meta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/system/notificationTemplates/index.vue?macro=true";
import { default as _91id_93DkgP67wMqJMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/system/organisations/[id].vue?macro=true";
import { default as indexbaCzRaApXjMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/system/organisations/index.vue?macro=true";
import { default as _91id_93qt34gJl01yMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/system/plans/[id].vue?macro=true";
import { default as index30ykiW8IfcMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/system/plans/index.vue?macro=true";
import { default as releaselogcf54An8aioMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/system/releaselog.vue?macro=true";
import { default as toolsDbExyIHAshMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/system/tools.vue?macro=true";
import { default as _91id_93HUux31JrDcMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/system/users/[id].vue?macro=true";
import { default as index8KKfTEkG5mMeta } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/system/users/index.vue?macro=true";
export default [
  {
    name: "auth-activate",
    path: "/auth/activate",
    meta: activateS29gYq7aUIMeta || {},
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/auth/activate.vue")
  },
  {
    name: "auth-email-change",
    path: "/auth/email-change",
    meta: email_45change007Q3PmgBWMeta || {},
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/auth/email-change.vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: index0dwdLIcNfGMeta || {},
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/auth/index.vue")
  },
  {
    name: "auth-register-complete",
    path: "/auth/register-complete",
    meta: register_45completeVBDP4eZ033Meta || {},
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/auth/register-complete.vue")
  },
  {
    name: "auth-register",
    path: "/auth/register",
    meta: register78tnzTT48bMeta || {},
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/auth/register.vue")
  },
  {
    name: "auth-restore",
    path: "/auth/restore",
    meta: restoreqZDTwOcZWHMeta || {},
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/auth/restore.vue")
  },
  {
    name: "buzzer",
    path: "/buzzer",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/buzzer/index.vue")
  },
  {
    name: "dashboards-id",
    path: "/dashboards/:id()",
    meta: _91id_93Tug6tIoKAgMeta || {},
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/dashboards/[id].vue")
  },
  {
    name: "dashboards",
    path: "/dashboards",
    meta: indexazVHRFwGdMMeta || {},
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/dashboards/index.vue")
  },
  {
    name: "dashboards-token",
    path: "/dashboards/token",
    meta: tokenlZOU2VRUVlMeta || {},
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/dashboards/token.vue"),
    children: [
  {
    name: "dashboards-token-token",
    path: ":token()",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/dashboards/token/[token].vue")
  }
]
  },
  {
    name: "demo",
    path: "/demo",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/demo.vue")
  },
  {
    name: "events",
    path: "/events",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/events/index.vue")
  },
  {
    name: "impressum",
    path: "/impressum",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/impressum.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/index.vue")
  },
  {
    name: "organisation-deals-id",
    path: "/organisation/deals/:id()",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/organisation/deals/[id].vue")
  },
  {
    name: "organisation-deals",
    path: "/organisation/deals",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/organisation/deals/index.vue")
  },
  {
    name: "organisation-devices-id",
    path: "/organisation/devices/:id()",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/organisation/devices/[id].vue")
  },
  {
    name: "organisation-devices-HSLtoRGB",
    path: "/organisation/devices/HSLtoRGB",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/organisation/devices/HSLtoRGB.js")
  },
  {
    name: "organisation-devices",
    path: "/organisation/devices",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/organisation/devices/index.vue")
  },
  {
    name: "organisation-devices-RGBtoHSL",
    path: "/organisation/devices/RGBtoHSL",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/organisation/devices/RGBtoHSL.js")
  },
  {
    name: "organisation-eventTypes-id",
    path: "/organisation/eventTypes/:id()",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/organisation/eventTypes/[id].vue")
  },
  {
    name: "organisation-eventTypes",
    path: "/organisation/eventTypes",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/organisation/eventTypes/index.vue")
  },
  {
    name: "organisation-goals-id",
    path: "/organisation/goals/:id()",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/organisation/goals/[id].vue")
  },
  {
    name: "organisation-goals",
    path: "/organisation/goals",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/organisation/goals/index.vue")
  },
  {
    name: "organisation-groups-id",
    path: "/organisation/groups/:id()",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/organisation/groups/[id].vue")
  },
  {
    name: "organisation-groups",
    path: "/organisation/groups",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/organisation/groups/index.vue")
  },
  {
    name: "organisation-settings",
    path: "/organisation/settings",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/organisation/settings/index.vue")
  },
  {
    name: "organisation-subscriptions",
    path: "/organisation/subscriptions",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/organisation/subscriptions/index.vue")
  },
  {
    name: "organisation-users-id",
    path: "/organisation/users/:id()",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/organisation/users/[id].vue")
  },
  {
    name: "organisation-users",
    path: "/organisation/users",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/organisation/users/index.vue")
  },
  {
    name: "sounds-id",
    path: "/sounds/:id()",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/sounds/[id].vue")
  },
  {
    name: "sounds",
    path: "/sounds",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/sounds/index.vue"),
    children: [
  {
    name: "sounds-index-entries",
    path: "entries",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/sounds/index/entries.vue")
  },
  {
    name: "sounds-index-playlists",
    path: "playlists",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/sounds/index/playlists.vue")
  }
]
  },
  {
    name: "system-devices",
    path: "/system/devices",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/system/devices/index.vue")
  },
  {
    name: "system-firmware-id",
    path: "/system/firmware/:id()",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/system/firmware/[id].vue")
  },
  {
    name: "system-firmware",
    path: "/system/firmware",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/system/firmware/index.vue")
  },
  {
    name: "system-hardware-id",
    path: "/system/hardware/:id()",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/system/hardware/[id].vue")
  },
  {
    name: "system-hardware",
    path: "/system/hardware",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/system/hardware/index.vue")
  },
  {
    name: "system-logs",
    path: "/system/logs",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/system/logs/index.vue")
  },
  {
    name: "system-notificationTemplates-id",
    path: "/system/notificationTemplates/:id()",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/system/notificationTemplates/[id].vue")
  },
  {
    name: "system-notificationTemplates",
    path: "/system/notificationTemplates",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/system/notificationTemplates/index.vue")
  },
  {
    name: "system-organisations-id",
    path: "/system/organisations/:id()",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/system/organisations/[id].vue")
  },
  {
    name: "system-organisations",
    path: "/system/organisations",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/system/organisations/index.vue")
  },
  {
    name: "system-plans-id",
    path: "/system/plans/:id()",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/system/plans/[id].vue")
  },
  {
    name: "system-plans",
    path: "/system/plans",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/system/plans/index.vue")
  },
  {
    name: "system-releaselog",
    path: "/system/releaselog",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/system/releaselog.vue")
  },
  {
    name: "system-tools",
    path: "/system/tools",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/system/tools.vue")
  },
  {
    name: "system-users-id",
    path: "/system/users/:id()",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/system/users/[id].vue")
  },
  {
    name: "system-users",
    path: "/system/users",
    component: () => import("/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/pages/system/users/index.vue")
  }
]